import React from 'react';
import './LegalPage.css';
import Pricing from "../components/Pricing";

const AnalisisDatos = () => (
    <div className="legal-page">
        <h1>Análisis de Datos</h1>
        <h2>"Convierte datos en decisiones con IA de voz"</h2>
        <p>En un mundo donde los datos son el nuevo oro, la inteligencia artificial por voz se convierte en el puente que transforma información técnica en decisiones accionables. Con nuestros agentes de voz, puedes automatizar la recolección, clasificación y procesamiento de datos sin intervención humana directa.</p>
        <h3>🔍 ¿Qué puede hacer un agente de voz aquí?</h3>
        <ul>
            <li>Recoger respuestas habladas de encuestas o formularios orales</li>
            <li>Interpretar solicitudes de reportes y procesar datos según comandos por voz</li>
            <li>Acceder a dashboards o sistemas analíticos para brindar resultados resumidos en tiempo real</li>
        </ul>
        <h3>🛠 Tecnologías complementarias:</h3>
        <p>Python, Power BI, BigQuery, Pandas, Jupyter, entre otros.</p>
        <h3>💡 Ejemplo real:</h3>
        <p>Un gerente solicita a su asistente de voz: “Muéstrame las ventas del último trimestre filtradas por región”, y obtiene una respuesta clara con visualizaciones integradas o un resumen enviado a su correo.</p>
        <Pricing/>
    </div>
);
export default AnalisisDatos;
